<script>
    import Route, {router} from "./lib/Router/Router.svelte";
    import {cookie} from "./lib/cookie";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import localTransfers from "./stores/localTransfers";
    import shift$ from "./stores/shift$";
    import {APP_VERSION, LOCAL_STATUS, OBJECT_TYPE, USER_ROLE} from "./lib/constants";
    import Login from "./components/pages/Login.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Transfers from "./transfers/Transfers.svelte";
    import Calendar from "./calendar/Calendar.svelte";
    import Accounts from "./accounts/Accounts.svelte";
    import Hotels from "./hotels/Hotels.svelte";
    import Departments from "./departments/Departments.svelte";
    import Transporters from "./transporters/Transporters.svelte";
    import Taxis from "./taxis/Taxis.svelte";
    import Locations from "./locations/Locations.svelte";
    import VehicleTypes from "./vehicles/VehicleTypes.svelte";
    import Users from "./users/Users.svelte";
    import TransferEdit from "./transfers/TransferEdit.svelte";
    import LocalEdit from "./locals/LocalEdit.svelte";
    import LocalTransfers from "./locals/LocalTransfers.svelte";
    import Workspace from "./workspace/Workspace.svelte";
    import Tours from "./tours/Tours.svelte";
    import DriverEditModal from "./transporters/DriverEditModal.svelte";
    import Shifts from "./shifts/Shifts.svelte";
    import FirebaseComponent from "./components/FirebaseComponent.svelte";
    import SmsReport from "./workspace/SmsReport.svelte";

    import Reports from "./reports/Reports.svelte";
    import TourEdit from "./transfers/TourEdit.svelte";
    import Prices from "./prices/Prices.svelte";
    import Reservations from "./reservations/Reservations.svelte";
    import Offers from "./offers/Offers.svelte";
    import ReservationsReport from "./reservations/ReservationsReport.svelte";
    import NotificationPopup from "./transfers/NotificationPopup.svelte";

    let userInitialized = false;
    let appInitialized = false;
    let collectTimer = null;
    let shiftTimer = null;
    let notificationTransfers = null;

    let frBaseComponent;

    const initUser = async () => {
        // user.initialize();
        let coo = cookie.get('transfers') || null;
        if (coo) {
            $user.token = coo;
        }

        userInitialized = true;
    }

    const logoutUser = () => {
        frBaseComponent.closeAppChannel();
        frBaseComponent.closeTaxisChannel();
        frBaseComponent.close();
        user.clearToken();
        $localTransfers.list = null;
        shift$.clear();
        appInitialized = false;
        router.go('/app')();
    }

    const appInitialize = () => {
        const onSuccess = result => {
            $user.id = result.user.id;
            $user.name = result.user.name;
            $user.email = result.user.email;
            $user.role = parseInt(result.user.role);
            $user.driver_id = result.user.driver_id;
            $user.transporter_id = result.user.transporter_id;
            $user.departments = result.departments;
            $user.notification_type = result.user.notification_type;
            $user.notification_enabled = result.user.notification_enabled;
            $app.regions = result.regions;
            $app.vehicle_types = result.vehicle_types;
            $app.settings = result.settings;
            $app.tour_image_path = result.tour_image_path;
            $app.department_reservation_url = result.department_reservation_url;
            $app.new_reservations = result.new_reservations || 0;
            $app.collect_interval = result.collect_interval;
            $app.firebaseConfig = result.firebase;

            shift$.setShift(result.clocking_shift);

            if (user.isGod()) {
                notificationTransfers = result.to_notify && result.to_notify.length > 0 ? result.to_notify : null;
            }

            // REMOVED: SMS
            // $app.sms = result.sms;

            handleCollect(result);

            if ($app.collect_interval > 0) {
                collectTimer = setInterval(() => {
                    collect();
                }, $app.collect_interval);
            }

            if (user.canViewLocalTransfers()) {
                frBaseComponent.initialize();
                frBaseComponent.openAppChannel();
                if (user.isAdmin()) {
                    frBaseComponent.openTaxisChannel();
                }
            }

            if (result.version !== APP_VERSION) {
                alert("The app version is outdated.\nClear your browser cache and refresh this page to load the current version.");
            }

            appInitialized = true;
        }

        const onFailure = err => {
        };

        if (!$user.token) {
            console.log("NO USER TOKEN", $user.token);
            return;
        }

        R.handle(R.app.initialize, [], onSuccess, onFailure);
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    const collect = () => {
        const onSuccess = result => {
            handleCollect(result);
        }

        const onFailure = err => {
        };

        R.handle(R.app.collect, [], onSuccess, onFailure);
    }

    const handleCollect = (result) => {
        let localsChecksum = result.collect.map(item => {
            if (item.object_type == OBJECT_TYPE.LOCAL) {
                return `${item.object_id}-${item.status_id}`;
            }
        });
        localsChecksum = localsChecksum.join("|");
        if ($localTransfers.new_locals != result.new_locals || (localsChecksum && $localTransfers.checksum != localsChecksum)) {
            $localTransfers.changed = true;
        }
        $localTransfers.new_locals = result.new_locals;
        $localTransfers.checksum = localsChecksum;
        $app.new_reservations = result.new_reservations || 0;
    }

    initUser();

    /* Firebase component events */

    // Fired from firebase when local_channel has been modified
    const appChannelChange = ({detail}) => {
        // new transfer
        if (detail.status_id == LOCAL_STATUS.OPEN && detail.operator_id != $user.id) {
            playNotification(LOCAL_STATUS.OPEN);
        }
        // assigned to transporter
        if (detail.status_id == LOCAL_STATUS.ASSIGNED && detail.transporter_id == $user.transporter_id) {
            playNotification(LOCAL_STATUS.ASSIGNED);
        }
        if (detail.operator_id == $user.id && detail.edited_by != $user.id) {
            if (detail.status_id == LOCAL_STATUS.REJECTED) {
                playNotification(LOCAL_STATUS.REJECTED);
            }
        }
        collect();
    }

    const onTaxiResponse = ({detail}) => {
        collect();
    }

    const onLocalTransferChange = (obj) => {
        $localTransfers.changed = true;
        if (obj.status_id == LOCAL_STATUS.ASSIGNED && obj.taxi_id > 0) {
            frBaseComponent.assignLocalToTaxi(obj);
        }
        frBaseComponent.updateLocalTransfer(obj);
    }

    const playNotification = (status = 0) => {
        // if (!$localTransfers.notifications) {
        //     return;
        // }
        const sound = document.getElementById(`alert-${status}`);
        if (sound) {
            sound.play();
        }
    }

    $: {
        if ($user.token && !appInitialized) {
            appInitialize();
        }

        if (appInitialized) {
            // if (router.url === "/" || router.url === "/app") {
            if (window.location.pathname === "/" || window.location.pathname === "/app") {
                if ($user.role == USER_ROLE.LOCAL_ADMIN) {
                    router.go("/app/locals")();
                } else {
                    if ($shift$.id) {
                        router.go("/app/shifts")();
                    } else {
                        router.go("/app/calendar")();
                    }
                }
            }
        }

        if ($shift$.id > 0 && !shiftTimer) {
            shift$.setDuration();
            shiftTimer = setInterval(() => {
                $shift$.duration = new Date() - $shift$.start_at;
            }, 1000);
        }
        if ($shift$.id == 0 && shiftTimer) {
            clearInterval(shiftTimer);
            shiftTimer = null;
        }
    }
</script>


{#if !$user.token}
    <Login/>
{:else if appInitialized}
    <PageLoader/>
    <PopupLoader/>
    <AppHeader on:logout={ logoutUser }/>
    <AppMenu/>
    <main>
        <div class="app-main-content">
            <div class="container-fluid">
                <!--- debug collect -->
                {#if $app.collect_interval == 0}
                    <button class="btn btn-default btn-xs" on:click={ collect }>Debug Collect</button>
                {/if}
                <Route match="/">
                    <Route match="app">
                        <Route match="new-transfer" guard={ user.canMakeTransfers }>
                            <TransferEdit transferId="0"/>
                        </Route>
                        <Route match="departure" let:router>
                            <TransferEdit transferId="{ router.id }" returnTrip/>
                        </Route>
                        <Route match="transfer" let:router>
                            <TransferEdit transferId="{ router.id }"/>
                        </Route>
                        <Route match="transfers" guard={ user.canViewTransfers }>
                            <Transfers/>
                        </Route>
                        <Route match="new-tour" guard={ user.canMakeTransfers }>
                            <TourEdit tourId="0"/>
                        </Route>
                        <Route match="tour" let:router>
                            <TourEdit tourId="{ router.id }"/>
                        </Route>
                        <Route match="new-local" guard={ user.canMakeLocalTransfers }>
                            <LocalEdit localId="0" changeCallback={onLocalTransferChange}/>
                        </Route>
                        <Route match="local" let:router>
                            <LocalEdit localId="{ router.id }" changeCallback={onLocalTransferChange}/>
                        </Route>
                        <Route match="locals" guard={ user.canViewLocalTransfers }>
                            <LocalTransfers/>
                        </Route>
                        <Route match="calendar" guard={ user.canViewCalendar }>
                            <Calendar/>
                        </Route>
                        <Route match="account" guard={ user.isGod }>
                            <Accounts/>
                        </Route>
                        <Route match="hotel" guard={ user.isGod }>
                            <Hotels/>
                        </Route>
                        <Route match="department" guard={ user.isGod }>
                            <Departments/>
                        </Route>
                        <Route match="transporter" guard={ user.isGod }>
                            <Transporters/>
                        </Route>
                        <Route match="taxi" guard={ user.isGod }>
                            <Taxis/>
                        </Route>
                        <Route match="location" guard={ user.isGod }>
                            <Locations/>
                        </Route>
                        <Route match="prices" guard={ user.isGod }>
                            <Prices/>
                        </Route>
                        <Route match="vehicle-types" guard={ user.isGod }>
                            <VehicleTypes/>
                        </Route>
                        <Route match="workspace" guard={ user.isGod }>
                            <Workspace/>
                        </Route>
                        <Route match="tours" guard={ user.isGod }>
                            <Tours/>
                        </Route>
                        <Route match="shifts" guard={ user.isDriver }>
                            <Shifts/>
                        </Route>
                        <Route match="user" guard={ user.isGod }>
                            <Users/>
                        </Route>
                        <Route match="reports" guard={ user.isGod }>
                            <Reports/>
                        </Route>
                        <Route match="sms-report" guard={ user.isGod }>
                            <SmsReport/>
                        </Route>
                        <Route match="reservations" guard={ user.isGod }>
                            <Reservations/>
                        </Route>
                        <Route match="reservations-report" guard={ user.isGod }>
                            <ReservationsReport/>
                        </Route>
                        <Route match="offers" guard={ user.isGod }>
                            <Offers/>
                        </Route>
                    </Route>
                </Route>
            </div>
        </div>
    </main>

    <div>
        <audio id="alert-{ LOCAL_STATUS.OPEN}" src="/assets/sounds/alert-open.wav" type="audio/wav"></audio>
        <audio id="alert-{ LOCAL_STATUS.ASSIGNED}" src="/assets/sounds/alert-assigned.wav" type="audio/wav"></audio>
        <audio id="alert-{ LOCAL_STATUS.REJECTED}" src="/assets/sounds/alert-rejected.wav" type="audio/wav"></audio>
    </div>
    {#if $app.driver}
        <DriverEditModal driverId="{ $app.driver.id }" transporterId="{$app.driver.transporter_id}"
                         closeCallback="{ $app.driver.closeCallback }"/>
    {/if}
{/if}

{#if notificationTransfers}
    <NotificationPopup bind:transfers={notificationTransfers}/>
{/if}

<Alert/>
<Notifier/>
<FirebaseComponent bind:this={ frBaseComponent }
                   on:app_channel={ appChannelChange }
                   on:taxi_channel={ onTaxiResponse }
/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main {
            padding-left: 50px;
        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main {
            padding-left: var(--aside-width);
        }

        main .app-main-content {
            padding: 30px 10px 20px 10px;
        }
    }
</style>